<script lang="ts" setup>
  interface IconProps {
    svgPathClass?: string
    size?: number
  }

  withDefaults(defineProps<IconProps>(), {
    svgPathClass: 'stroke-black dark:stroke-white',
    size: 16,
  })
</script>

<template>
  <svg
    data-testid="search-icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_166_10298)">
      <path
        d="M15.25 15.25L11.5 11.5M0.75 7C0.75 3.54822 3.54822 0.75 7 0.75C10.4518 0.75 13.25 3.54822 13.25 7C13.25 10.4518 10.4518 13.25 7 13.25C3.54822 13.25 0.75 10.4518 0.75 7Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        :class="svgPathClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_166_10298">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
